var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"MyChartDom",style:({ width: '100%', height: '100%' }),on:{"click":_vm.sizechange}})
}
var staticRenderFns = []

export { render, staticRenderFns }